









































import { defineComponent, ref, onMounted, onUnmounted, computed } from "@vue/composition-api";
import { Vue } from "vue/types/vue";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useKeepCustomScrollPosition from "@/hooks/useKeepCustomScrollPosition";
import providers from "@/lib/api";
import config from "@/config";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSendMessage from "@/components/BaseSendMessage";
import CustomScroll from "@/components/CustomScroll";
import SendMessageController from "@/components/SendMessageController";
import TipController from "@/components/TipController";
import TipIcon from "@/components/TipIcon";
import StreamMessage from "../StreamMessage";

export default defineComponent({
  name: "StreamChat",
  components: {
    SendMessageController,
    BaseSendMessage,
    StreamMessage,
    CustomScroll,
    BaseIconButton,
    TipController,
    TipIcon,
  },
  props: {
    threadId: { type: String, required: true },
    token: { type: String, required: true },
  },
  setup(props) {
    const value = ref<string>("");
    const scrollbarWidth = ref(0);
    const sending = ref(false);
    const messageList = ref<Message[]>([]);
    const messageListNode = ref<Vue | undefined>();
    const { authUser } = useAuthUser();
    const { shouldScrollToBottom, scrollNode } = useKeepCustomScrollPosition(messageListNode, { behavior: "smooth" });

    const onNewMessageReceived = (message: Message) => {
      messageList.value = messageList.value.concat([message]);
      if (!scrollNode.value) return;
      const bottomScrollTopPosition = scrollNode.value.scrollHeight - scrollNode.value.offsetHeight;
      if (message.senderId === authUser.value?.id || bottomScrollTopPosition - scrollNode.value.scrollTop <= 100) {
        shouldScrollToBottom.value = true;
      }
    };

    let unsubscribe = () => {};
    const subscribeLiveChatNewMessages = async () => {
      const subscription = await providers.LivechatsProvider.subscribeMessageReceived(
        props.token,
        onNewMessageReceived
      );
      unsubscribe = () => subscription.unsubscribe();
    };
    onUnmounted(() => unsubscribe());

    onMounted(() => {
      subscribeLiveChatNewMessages();
    });

    const canTip = computed<boolean>(() => config.featureTippingLive && !(value.value.length > 0));

    return { messageList, sending, messageListNode, scrollbarWidth, value, canTip };
  },
});
